<div class="page-container">
  <!-- KAN-147: Monthly statements (default) | Manual statements -->
  <div class="tab-bar" role="tablist" aria-label="Artist statement views">
    <button type="button" role="tab" class="tab-btn" id="tab-monthly" aria-controls="panel-monthly"
      [attr.aria-selected]="view === 'monthly'" [attr.tabindex]="view === 'monthly' ? 0 : -1" [class.active]="view === 'monthly'"
      (click)="setView('monthly')" (keydown.arrowRight)="setView('manual', true)" (keydown.arrowLeft)="setView('manual', true)">Monthly statements</button>
    <button type="button" role="tab" class="tab-btn" id="tab-manual" aria-controls="panel-manual"
      [attr.aria-selected]="view === 'manual'" [attr.tabindex]="view === 'manual' ? 0 : -1" [class.active]="view === 'manual'"
      (click)="setView('manual')" (keydown.arrowRight)="setView('monthly', true)" (keydown.arrowLeft)="setView('monthly', true)">Manual statements</button>
  </div>

  <div id="panel-monthly" role="tabpanel" aria-labelledby="tab-monthly" *ngIf="view === 'monthly'">
    <div class="page-header">
      <h2>Artist Statement</h2>
    </div>
    <app-artist-monthly-statements></app-artist-monthly-statements>
  </div>

  <div id="panel-manual" role="tabpanel" aria-labelledby="tab-manual" *ngIf="view === 'manual'">
  <div class="page-header">
    <h2>Artist Statement</h2>
    <div class="controls">
      <div class="selection-container">
        <select [(ngModel)]="selectedPeriod" class="period-select">
          <option value="All Periods">All Periods</option>
          <option *ngFor="let period of periods" [value]="period">{{ period }}</option>
        </select>
      </div>
      <button class="primary-btn" (click)="openCreateModal()">+ Create Statement</button>
    </div>
  </div>

  <div class="card no-padding">
    <table class="data-table">
      <thead>
        <tr>
          <th>Period</th>
          <th>Company</th>
          <th>Artist</th>
          <th class="text-right">Total Frames</th>
          <th class="text-right">Total Amount (USD)</th>
          <th class="text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="isLoadingGrid">
          <td colspan="6" class="text-center loading-row">
            <div class="spinner spinner-sm"></div> Loading...
          </td>
        </tr>
        <ng-container *ngIf="!isLoadingGrid">
          <tr *ngFor="let row of filteredStatements">
            <td>{{ row.period }}</td>
            <td class="fw-500">{{ row.companyName }}</td>
            <td class="fw-500">{{ row.artistName }}</td>
            <td class="text-right">{{ row.totalQuantity }}</td>
            <td class="text-right fw-600 text-success">{{ row.totalAmount | currency }}</td>
            <td class="text-center">
              <button class="icon-action-btn" (click)="viewStatement(row)" title="View">👁️</button>
              <button class="icon-action-btn danger" (click)="deleteStatement(row.id!)" title="Delete">🗑️</button>
            </td>
          </tr>
          <tr *ngIf="filteredStatements.length === 0">
            <td colspan="6" class="empty-table-msg">No statements found.</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  </div>
</div>

<!-- Create Statement Modal -->
<div class="modal-overlay" *ngIf="isModalOpen" (click)="closeModal()">
  <div class="modal-content large-modal" (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h2>Create Artist Statement</h2>
      <button class="close-btn-static" (click)="closeModal()">&times;</button>
    </div>

    <div class="form-grid">
      <div class="form-group">
        <label>Statement Period *</label>
        <select [(ngModel)]="newStatement.period" class="form-input">
          <option value="" disabled>Select Period</option>
          <option *ngFor="let period of periods" [value]="period">{{ period }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>Company *</label>
        <select [(ngModel)]="newStatement.companyId" class="form-input">
          <option value="" disabled>Select Company</option>
          <option *ngFor="let c of companies" [value]="c.id">{{ c.company }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>Artist *</label>
        <select [(ngModel)]="newStatement.artistId" (change)="onArtistChange()" class="form-input">
          <option value="" disabled>Select Artist</option>
          <option *ngFor="let a of artists" [value]="a.id">{{ a.name }}</option>
        </select>
      </div>
    </div>

    <div class="items-section" *ngIf="newStatement.artistId">
      <h4 class="section-title">Statement Items</h4>
      
      <!-- Add Item Row -->
      <div class="add-item-row">
      <div class="form-group flex-2">
        <label class="sm-label">Frame ID</label>
        <input [(ngModel)]="newItem.frameId" placeholder="e.g. FRM-001" class="form-input form-input-sm">
      </div>
      <div class="form-group flex-2">
        <label class="sm-label">Frame Image</label>
        <div class="image-upload-wrapper">
          <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" style="position: absolute; opacity: 0; width: 1px; height: 1px; pointer-events: none;">
          
          <button type="button" *ngIf="!newItem.frameImage" class="secondary-btn btn-sm" 
                  (click)="triggerFileInput(fileInput)" [disabled]="isUploadingImage || !newStatement.artistId || !newStatement.period">
            <span *ngIf="isUploadingImage" class="spinner spinner-sm"></span>
            <span *ngIf="!isUploadingImage">Upload Image</span>
          </button>
          
          <div *ngIf="newItem.frameImage" class="image-preview-wrapper">
            <img [src]="newItem.frameImage" class="preview-img">
            <button class="icon-action-btn danger btn-xs" (click)="removeImage()" title="Remove Image">🗑️ Remove</button>
          </div>
        </div>
      </div>
      <div class="form-group flex-1">
        <label class="sm-label">Quantity</label>
        <input type="number" [(ngModel)]="newItem.quantity" (ngModelChange)="calculateItemTotal()" class="form-input form-input-sm" min="1">
      </div>
      <div class="form-group flex-1">
        <label class="sm-label">Commission ($)</label>
        <input type="number" [(ngModel)]="newItem.commission" disabled class="form-input form-input-sm bg-gray">
      </div>
      <div class="form-group flex-1">
        <label class="sm-label">Total ($)</label>
        <input type="number" [(ngModel)]="newItem.total" disabled class="form-input form-input-sm bg-gray">
      </div>
      <button class="primary-btn btn-md" (click)="addItem()" [disabled]="!newItem.frameId || !newItem.quantity || !newStatement.artistId">Add</button>
    </div>

    <!-- Items Grid -->
    <table class="data-table mb-20">
      <thead>
        <tr>
          <th>Frame ID</th>
          <th>Image</th>
          <th class="text-right">Quantity</th>
          <th class="text-right">Commission</th>
          <th class="text-right">Total</th>
          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of newStatement.items; let i = index">
          <td>{{ item.frameId }}</td>
          <td>
            <img *ngIf="item.frameImage" [src]="item.frameImage" class="table-img">
            <span *ngIf="!item.frameImage" class="text-muted-sm">No Image</span>
          </td>
          <td class="text-right">{{ item.quantity }}</td>
          <td class="text-right">{{ item.commission | currency }}</td>
          <td class="text-right fw-600">{{ item.total | currency }}</td>
          <td class="text-center">
             <button class="icon-action-btn danger" (click)="removeItem(i)" title="Remove Item">🗑️</button>
          </td>
        </tr>
        <tr *ngIf="!newStatement.items || newStatement.items.length === 0">
          <td colspan="6" class="empty-table-msg">No items added yet.</td>
        </tr>
      </tbody>
      <tfoot *ngIf="newStatement.items && newStatement.items.length > 0">
        <tr>
          <th colspan="2" class="text-right">Grand Total:</th>
          <th class="text-right">{{ newStatement.totalQuantity }}</th>
          <th></th>
          <th class="text-right fw-600 text-success">{{ newStatement.totalAmount | currency }}</th>
          <th></th>
        </tr>
      </tfoot>
    </table>
    </div>

    <div class="modal-actions">
      <button class="secondary-btn" (click)="closeModal()" [disabled]="isSaving">Cancel</button>
      <button class="primary-btn" (click)="saveStatement()" [disabled]="isSaving">
        {{ isSaving ? 'Saving...' : 'Save Statement' }}
      </button>
    </div>
  </div>
</div>

<!-- View Statement Modal -->
<div class="modal-overlay" *ngIf="isViewModalOpen" (click)="closeViewModal()">
  <div class="modal-content invoice-modal" (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h2>Artist Statement</h2>
      <div style="display: flex; gap: 10px; align-items: center;">
        <button class="action-btn view-btn" (click)="savePdf()" [disabled]="isGeneratingPdf">
          {{ isGeneratingPdf ? 'Generating...' : 'Save to PDF' }}
        </button>
        <button class="action-btn view-btn" (click)="openPdfInNewTab()" [disabled]="isGeneratingPdf">
          {{ isGeneratingPdf ? 'Generating...' : 'Open PDF' }}
        </button>
        <button class="close-btn-static" (click)="closeViewModal()">&times;</button>
      </div>
    </div>
    
    <!-- Normal View Template (not PDF mode) -->
    <app-artist-statement-template *ngIf="selectedStatementForPdf" [statement]="selectedStatementForPdf"></app-artist-statement-template>
  </div>
</div>

<!-- Hidden container for actual PDF generation -->
<div class="print-container">
  <div id="pdf-content" class="invoice-modal">
    <app-artist-statement-template *ngIf="selectedStatementForPdf" [statement]="selectedStatementForPdf" [forPdf]="true"></app-artist-statement-template>
  </div>
</div>
